import { AiSuiteTool, aiColors } from '@euler/app/flows/ai-suite/theme';
import { AiAgentBundleId, AiHomeFeature } from '@euler/model/ai-home';
import { ChartLine, ChartPie, Database, Sparkles } from 'lucide-react-native';

/** The chat on a dataset (**用 AI 分析**): its chip, empty state, hint. */
export const kBiDatasetChatTool: AiSuiteTool = {
  kind: 'chat',
  feature: AiHomeFeature.BusinessIntelligence,
  title: '数据分析',
  subtitle: '就这份数据提问',
  color: aiColors.amber,
  icon: Database,
  bundleId: AiAgentBundleId.Workshop,
  heading: '想从这份数据里看什么？',
  intro: '直接问我，我会查询这份数据并画成图表。',
  placeholder: '想从这份数据里看什么…',
  starters: [
    {
      text: '这份数据里有什么值得看的？',
      icon: Sparkles,
      color: aiColors.blue,
    },
    { text: '按月看看总数的变化', icon: ChartLine, color: aiColors.green },
    { text: '哪些类别占比最高？', icon: ChartPie, color: aiColors.violet },
  ],
};
